
// import React ,{useState}from 'react'
// import styled from "styled-components"
// import MenuIcon from '@mui/icons-material/Menu';
// import { SvgIcon } from '@mui/material';
// // import CloseIcon from '@material-ui/icons/Close';
// import CloseIcon from '@mui/icons-material/Close';

// function Head() {
//   const[burgerStatus,setBurgerStatus]=useState(false);
//   return (
//     <Container>
//       <a>
//         <img src="/images/logo.svg" alt=""/>
//       </a>
//       <Menu>
//     <a href="#">Model S</a>
//     <a href="#">Model 3</a>
//     <a href="#">Model x</a>
//     <a href="#">Model y</a>
    
//       </Menu>
//       <RightMenu>
//         <a href="#">Shop</a>
//         <a href="#">TeslaAccount</a>
//         <CustomMenu onClick={()=>setBurgerStatus(true)}/>
//       </RightMenu>
//       <BurgerNav show={burgerStatus}>
//         <CloseWrapper>
//         <CustomClose onClick={()=>setBurgerStatus(false)}/>
//         </CloseWrapper>
        
//         <li><a href="#">Existing Inventrory</a></li>
//         <li><a href="#">Used Inventrory</a></li>
//         <li><a href="#">Trad-in</a></li>
//         <li><a href="#">Cybertruck</a></li>
//         <li><a href="#">Roadaster</a></li>
//         <li><a href="#">Existing Inventrory</a></li>
//         <li><a href="#">Existing Inventrory</a></li>
//         <li><a href="#">Existing Inventrory</a></li>
//       </BurgerNav>
//     </Container>
//   )
// }

// export default Head
// const Container=styled.div`
// min-height:60px;
// positon:fixed;
// display:flex;
// align-items:center;
// padding:0 20px;
// top:0;
// left:0;
// right:0;
// justify-content:space-between;
// z-index:1;

// `
// const Menu=styled.div`
// display:flex;
// align-items:center;
// flex:1;
// justify-content:center;
// a{
// font-weight:600;
// text-transform:uppercase;
// padding:0 10px;
// flex-wrap:nowrap;

// }
// @media(max-width:768px){
// dispaly:none;
// }
// `
// const RightMenu=styled.div`
// display:flex;
// align-items:center;
// a{
// font-weight:600;
// text-transform:uppercase;
// margin-right:10px
// }
// `
// const CustomMenu=styled(MenuIcon)`
// cursor:pointer;

// `
// const BurgerNav=styled.div`
// position:fixed;
// top:0;
// bottom:0;
// right:0;
// background:white;
// width:300px;
// z-index:16;
// list-style:none;
// padding:20px;
// display:flex;
// flex-direction:column;
// text-align:start;
// transform: ${props=>props.show ? 'translateX(0)':'translate(100%)'}
// transition:transform 0.2s;
// li{
// padding:15px 0;
// border-bottom:1px solid rgba(0,0,0,.2);
// }
// `
// const CustomClose=styled(CloseIcon)`
// cursor:pointer;
// `
// const CloseWrapper=styled.div`
// display:flex;
// justify-content:flex-end;

// `




import React, { useState } from "react";
import styled from "styled-components";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import {selectCars} from '../features/car/carSlice';
import {useSelector} from 'react-redux';

function Head() {
  const [burgerStatus, setBurgerStatus] = useState(false);
  // const cars=useSelector(selectCars)
  const cars = useSelector((state) => state.car?.cars || []);


  return (
    <Container>
      <a>
        <img src="/images/logo.svg" alt="Tesla Logo" />
      </a>
      <Menu>
        { cars && cars.map((car,index)=>(
           <a key={index} href="#">{car}</a>
        )
        )}
       
      </Menu>
      <RightMenu>
        <a href="#">Shop</a>
        <a href="#">Tesla Account</a>
        <CustomMenu onClick={() => setBurgerStatus(true)} />
      </RightMenu>
      <BurgerNav show={burgerStatus}>
        <CloseWrapper>
          <CustomClose onClick={() => setBurgerStatus(false)} />
        </CloseWrapper>
      
        {cars && cars.map((car, index) => (
  <li key={index}><a href="#">{car}</a></li>
))}

        <li><a href="#">Existing Inventory</a></li>
        <li><a href="#">Used Inventory</a></li>
        <li><a href="#">Trade-in</a></li>
        <li><a href="#">Cybertruck</a></li>
        <li><a href="#">Roadster</a></li>
      </BurgerNav>
    </Container>
  );
}

export default Head;

const Container = styled.div`
  min-height: 60px;
  position: fixed;
  display: flex;
  align-items: center;
  padding: 0 20px;
  top: 0;
  left: 0;
  right: 0;
  justify-content: space-between;
  z-index: 1;
`;

const Menu = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;

  a {
    font-weight: 600;
    text-transform: uppercase;
    padding: 0 10px;
    flex-wrap: nowrap;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const RightMenu = styled.div`
  display: flex;
  align-items: center;

  a {
    font-weight: 600;
    text-transform: uppercase;
    margin-right: 10px;
  }
`;

const CustomMenu = styled(MenuIcon)`
  cursor: pointer;
`;

const BurgerNav = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  background: white;
  width: 300px;
  z-index: 16;
  list-style: none;
  padding: 20px;
  display: flex;
  flex-direction: column;
  text-align: start;
  transition: transform 0.2s ease-in-out;

  // transform: ${(props) => (props.show ? "translateX(0)" : "translateX(100%)")};
  transform: ${(props) => (props.show ? "translateX(0)" : "translateX(100%)")};


  li {
    padding: 15px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }
`;

const CustomClose = styled(CloseIcon)`
  cursor: pointer;
`;

const CloseWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;




// import React, { useState } from "react";
// import styled from "styled-components";
// import MenuIcon from "@mui/icons-material/Menu";
// import CloseIcon from "@mui/icons-material/Close";
// import { useSelector } from "react-redux";
// import { selectCars } from "../features/car/carSlice";

// function Head() {
//   const [burgerStatus, setBurgerStatus] = useState(false);
//   const cars = useSelector((state) => state.car?.cars || []);

//   return (
//     <Container>
//       <a href="#">
//         <img src="/images/logo.svg" alt="Tesla Logo" />
//       </a>
//       <Menu>
//         {cars.map((car, index) => (
//           <a key={index} href="#">{car}</a>
//         ))}
//       </Menu>
//       <RightMenu>
//         <a href="#">Shop</a>
//         <a href="#">Tesla Account</a>
//         <CustomMenu onClick={() => setBurgerStatus(true)} />
//       </RightMenu>
//       <BurgerNav show={burgerStatus}>
//         <CloseWrapper>
//           <CustomClose onClick={() => setBurgerStatus(false)} />
//         </CloseWrapper>
//         {cars.map((car, index) => (
//           <li key={index}><a href="#">{car}</a></li>
//         ))}
//         <li><a href="#">Existing Inventory</a></li>
//         <li><a href="#">Used Inventory</a></li>
//         <li><a href="#">Trade-in</a></li>
//         <li><a href="#">Cybertruck</a></li>
//         <li><a href="#">Roadster</a></li>
//       </BurgerNav>
//     </Container>
//   );
// }

// export default Head;

// // Styled Components
// const Container = styled.div`
//   min-height: 60px;
//   position: fixed; /* Fixed typo */
//   display: flex;
//   align-items: center;
//   padding: 0 20px;
//   top: 0;
//   left: 0;
//   right: 0;
//   justify-content: space-between;
//   z-index: 1;
// `;

// const Menu = styled.div`
//   display: flex;
//   align-items: center;
//   flex: 1;
//   justify-content: center;

//   a {
//     font-weight: 600;
//     text-transform: uppercase;
//     padding: 0 10px;
//     flex-wrap: nowrap;
//   }

//   @media (max-width: 768px) {
//     display: none; /* Fixed typo */
//   }
// `;

// const RightMenu = styled.div`
//   display: flex;
//   align-items: center;

//   a {
//     font-weight: 600;
//     text-transform: uppercase;
//     margin-right: 10px;
//   }
// `;

// const CustomMenu = styled(MenuIcon)`
//   cursor: pointer;
// `;

// const BurgerNav = styled.div`
//   position: fixed;
//   top: 0;
//   bottom: 0;
//   right: 0;
//   background: white;
//   width: 300px;
//   z-index: 16;
//   list-style: none;
//   padding: 20px;
//   display: flex;
//   flex-direction: column;
//   text-align: start;
//   transform: ${({ show }) => (show ? "translateX(0)" : "translateX(100%)")};
//   transition: transform 0.2s ease-in-out;

//   li {
//     padding: 15px 0;
//     border-bottom: 1px solid rgba(0, 0, 0, 0.2);
//   }
// `;

// const CustomClose = styled(CloseIcon)`
//   cursor: pointer;
// `;

// const CloseWrapper = styled.div`
//   display: flex;
//   justify-content: flex-end;
// `;
